import { StepNavigationSwitch } from '../../atoms/step-navigation-switch';
import { ManualCardEntryStepNavigationProps } from './manual-card-entry.types';
import { ManualCardEntryGenericNavigation } from './navigation/manual-card-entry-generic-navigation';

export const ManualCardEntryNavigationSwitch = ({ body }: ManualCardEntryStepNavigationProps) => {
  return <StepNavigationSwitch generic={ManualCardEntryGenericNavigation} body={body} />;
};
